module.exports = __webpack_public_path__ + "img/bg_row_1eee.23861f7f.svg";